/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { IconButton, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Zoom from "@material-ui/core/Zoom";
import DarkTooltip from "../../../../elements/DarkTooltip";
import { FormattedMessage } from "react-intl";

const ScopesCopyIcon = '/icons/copy.svg';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    copyAllScopes: {
        ...theme.custom.apiOverviewPage.tabs.overview.copyAllScopes
    },
    copyScopesText: {
        ...theme.custom.apiOverviewPage.tabs.overview.copyScopesText
    },
}));

interface CopyCommandProps {
    copyCmd: string;
}

export default function CopyCommand(props: CopyCommandProps) {
    const classes = useStyles();
    const { copyCmd } = props;
    const [copiedTooltipVisible, setCopiedTooltipVisible] = useState(false);

    const handleCopyClick = (event: any) => {
        navigator.clipboard.writeText(copyCmd);
        setCopiedTooltipVisible(true);
        setTimeout(() => {
            setCopiedTooltipVisible(false);
        }, 2000);
    };

    return (
        <DarkTooltip
            title={
                <FormattedMessage
                    id='api.apiOverview.apiScopes.tooltip.copied'
                    defaultMessage='Copied'
                />
            }
            TransitionComponent={Zoom}
            placement='right'
            open={copiedTooltipVisible}
        >
            <IconButton
                id="copy-scopes-btn"
                onClick={handleCopyClick}
                className={classes.copyAllScopes}
                data-testid="copy-scopes-btn"
                disableRipple
            >
                <img src={ScopesCopyIcon} alt="scopes-copy"/>
                <Typography className={classes.copyScopesText}>
                    <FormattedMessage
                        id="api.apiOverview.apiScopes.labels.copyAll"
                        defaultMessage="Copy All"
                    />
                </Typography>
            </IconButton>
        </DarkTooltip>
    );
}
